import {
  GridSalePricev2,
  PriceView,
  Quantity,
  StarRating,
} from "@/Components/Index";
import { useContextCheckoutData } from "@/Context/Checkout/ContextCheckoutProvider";
import { useContextProductData } from "@/Context/Product/ContextProductProvider";
import { useContextTicketProvider } from "@/Context/Ticket/ContextTicketCartProvider";
import useWindowsSize from "@/Hooks/useWindowsSize";
import type { ProductByIdPdp } from "@/Models/MPDP/ProductByIdPDP";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";

type propsInformation = {
  CategoriesFather: string;
  Products?: ProductByIdPdp[];
  PromotionsDescription?: string[];
  Promotions?: string[];
};

const DataInformation = ({
  CategoriesFather,
  Products,
  PromotionsDescription,
  Promotions,
}: propsInformation) => {
  const { width } = useWindowsSize();
  const { isLoading, Categories, AddQuantity, Quantitys } =
    useContextProductData();
  const { AddCart, AddCartMoreQuantity, ViewCart } = useContextCheckoutData();
  const { AddTicketCart } = useContextTicketProvider();
  const Productos = Products?.map((item) => item)[0];

  const ViewButton = ({
    text,
    toLink,
    click,
  }: {
    text: string;
    toLink: string;
    click?: () => void;
  }): JSX.Element => {
    return (
      <Link
        className={`ps-btn text-white d-block ${width < 860 ? "mt-3" : ""}`}
        to={toLink}>
        {text}
      </Link>
    );
  };

  const ButtonPdp = ({
    text,
    click,
  }: {
    text: string;
    click?: () => void;
  }): JSX.Element => {
    return (
      <button
        className={`ps-btn text-white d-block ${width < 860 ? "mt-3" : ""}`}
        onClick={click}>
        {text}
      </button>
    );
  };

  const AddCartProduct = () => {
    const imagenAddCart = Productos?.ImageGroups?.map(
      (item) => item.images.map((w) => w)[0]
    )[0];
    const salesPrice = parseInt(
      (Productos?.SalesPrice ?? "").replace(/,/g, "")
    );
    const listPrice = parseInt((Productos?.ListPrice ?? "").replace(/,/g, ""));

    const PriceList = salesPrice < listPrice ? salesPrice : listPrice;

    const QunatityCart = ViewCart(Productos?.Id ?? "");
    if (Number(QunatityCart) == 0) {
      AddCart(
        Productos?.Id ?? "",
        imagenAddCart?.alt ?? "",
        Productos?.Name ?? "",
        CategoriesFather ?? "",
        Productos?.CCategory ?? "",
        PriceList,
        imagenAddCart?.link ?? "",
        Productos?.CSaleLimit ?? 0,
        Quantitys
      );
    }

    AddCartMoreQuantity(
      Productos?.Id ?? "",
      imagenAddCart?.alt ?? "",
      Productos?.Name ?? "",
      CategoriesFather ?? "",
      Productos?.CCategory ?? "",
      PriceList,
      imagenAddCart?.link ?? "",
      Productos?.CSaleLimit ?? 0,
      Quantitys
    );

    AddTicketCart(Productos!, Quantitys, Productos?.IpClient ?? "");
  };

  const heanddleAddCart = () => {
    const QunatityCart = ViewCart(Productos?.Id ?? "");

    if (Quantitys > 1) {
      console.log(
        `agregar : ${Quantitys} y -> cantidad ya agregada: ${Number(
          QunatityCart
        )}`
      );
      if (Number(QunatityCart) === Quantitys) return;

      const existData =
        Number(QunatityCart) > 0 ? Number(QunatityCart) - Quantitys : Quantitys;

      if (Math.abs(existData) == 1) AddCartProduct();
      else {
        for (let index = 0; index < Math.abs(existData); index++) {
          AddCartProduct();
        }
      }
    } else {
      if (Number(QunatityCart) > 0) return;
      AddCartProduct();
    }
  };

  return (
    <>
      <h1 className="develop__fontFamilys__titles">
        {isLoading ? <Skeleton /> : Productos?.Name}
      </h1>
      <div className="ps-product__meta">
        {isLoading ? (
          <p className="w-100">
            <Skeleton />
          </p>
        ) : (
          <>
            <p>
              Marca:<strong> {Productos?.Brand}</strong>
            </p>
            <p className="ps-product__rating border-right-0">
              <StarRating
                rating={Math.floor(
                  Number(Productos?.CBvAverageRating) > 0
                    ? Number(Productos?.CBvAverageRating)
                    : 1
                )}
                totales={
                  Number(Productos?.CBvRatingRange) > 0
                    ? Number(Productos?.CBvRatingRange)
                    : 5
                }
                fontStar={16}
                fontNumber={16}
              />
            </p>
          </>
        )}
      </div>
      <h4 className="ps-product__price">
        <PriceView
          salesPrice={Productos?.SalesPrice ?? ""}
          listPrice={Productos?.ListPrice ?? ""}
          isLoading={isLoading}
        />
      </h4>
      <div className="ps-product__desc">
        {isLoading ? (
          <div className="p-2">
            <Skeleton height={170} />
          </div>
        ) : (
          <>
            <p>
              Ver más detalles:
              <Link to={""}>
                {" "}
                <strong>{Categories}</strong>
              </Link>
            </p>
            <ul className="ps-list--dot">
              <li> Categoria: {Productos?.SubCategory}</li>
              {Number(Products?.length) > 0 &&
                PromotionsDescription?.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
            </ul>
          </>
        )}
      </div>
      <div className="ps-product__variations">
        <figure>
          {isLoading ? (
            <Skeleton height={70} />
          ) : (
            <>
              <figcaption>Color</figcaption>
              {Number(Promotions?.length) > 0 ? (
                Promotions?.map((item) => (
                  <div
                    className="ps-variant ps-variant--color"
                    style={{ backgroundColor: item }}
                    key={item}></div>
                ))
              ) : (
                <div className="p-2"></div>
              )}
            </>
          )}
        </figure>
      </div>
      <div className="ps-product__shopping">
        {isLoading ? (
          <div className="w-100">
            <Skeleton height={60} />
          </div>
        ) : (
          <>
            <figure className={width < 1080 ? "w-100 mb-3" : ""}>
              <figcaption>Cantidad</figcaption>
              <Quantity clickQuantity={AddQuantity} classNames="w-100" />
            </figure>
            <ButtonPdp text={"Agregar al carrito"} click={heanddleAddCart} />
            <ViewButton
              text={"Inicar Compra"}
              toLink={
                "/Electrónicav2/articles/c/Checkout/FinshBuy?viewCart=parcharsebuy.html"
              }
            />
          </>
        )}
      </div>
      {/* <div className="ps-product__specification">
            <a className="report" href="#">
              Report Abuse
            </a>
            <p>
              <strong>SKU:</strong> SF1133569600-1
            </p>
            <p className="categories">
              <strong> Categories:</strong>
              <a href="#">Consumer Electronics</a>,<a href="#"> Refrigerator</a>,
              <a href="#">Babies & Moms</a>
            </p>
            <p className="tags">
              <strong> Tags</strong>
              <a href="#">sofa</a>,<a href="#">technologies</a>,
              <a href="#">wireless</a>
            </p>
          </div> */}
      {/* <div className="ps-product__sharing">
            <a className="facebook" href="#">
              <i className="fa fa-facebook"></i>
            </a>
            <a className="twitter" href="#">
              <i className="fa fa-twitter"></i>
            </a>
            <a className="google" href="#">
              <i className="fa fa-google-plus"></i>
            </a>
            <a className="linkedin" href="#">
              <i className="fa fa-linkedin"></i>
            </a>
            <a className="instagram" href="#">
              <i className="fa fa-instagram"></i>
            </a>
          </div> */}
    </>
  );
};

export default DataInformation;
